export default {
  setQuery({ commit }, query) {
    commit("SET_QUERY", query);
  },
  selectFilter({ commit }, selectedFilter) {
    commit("SET_SELECTED_FILTER", selectedFilter);
  },
};
